// Shared visual language for the Discord LFG admin console, mirroring the bot
// landing / main landing design system (dark gradient cards, blurple accent,
// heavy uppercase headings) so the dashboard reads as the same product surface.

/** Discord blurple — same accent the bot landing uses. */
export const ACCENT = '#5865F2';
export const ACCENT_SOFT = '#8E9AFF';

/** Card surface used across the landing (Features/Pricing/steps cards). */
export const CARD_BG =
  'linear-gradient(165deg, hsla(228, 11.6%, 15%, 0.7) 0%, hsla(228, 11.6%, 9%, 0.4) 100%)';

/** Slightly stronger surface for primary/highlighted panels. */
export const CARD_BG_STRONG =
  'linear-gradient(165deg, hsla(228, 11.6%, 14%, 0.85) 0%, hsla(228, 11.6%, 9%, 0.6) 100%)';

/** Landing card shell: rounded, hairline border, gradient surface. */
export const cardProps = {
  borderRadius: '2xl',
  border: '1px solid',
  borderColor: 'whiteAlpha.100',
  background: CARD_BG,
} as const;

/** Landing-scoped contrast overrides (same values Landing/BuildWithUs set). */
export const landingContrastCss = {
  '--chakra-colors-fg-muted': 'rgba(255, 255, 255, 0.55)',
  '--chakra-colors-fg-subtle': 'rgba(255, 255, 255, 0.5)',
  '--chakra-colors-purple-300': '#8288f5',
  '--chakra-colors-purple-200': '#8288f5',
  '--chakra-colors-purple-fg': '#8288f5',
  '--chakra-colors-purple-solid': '#5158e2',
} as const;

/** Eyebrow label above headings ("ADMIN", "QUICK START", …). */
export const eyebrowProps = {
  fontSize: 'xs',
  fontWeight: '700',
  color: 'purple.300',
  textTransform: 'uppercase',
  letterSpacing: '0.15em',
} as const;

/** Heavy uppercase page heading, like the landing section titles. */
export const pageHeadingProps = {
  fontWeight: '900',
  lineHeight: '1.05',
  textTransform: 'uppercase',
  letterSpacing: '-0.02em',
} as const;
